module.exports = __webpack_public_path__ + "media/components/slider/s9-47bd77a4dd960f3c91418142cd22a040.jpg";